import { createSlice } from "@reduxjs/toolkit";

// project imports
import { dispatch } from "../index";
import { getQueryVariable } from "utils";

// initial state
export const initialState: AuthState = {
  isLoggedIn: true,
  isInitialized: false,
  user: null
};

// ==============================|| SLICE - AUTH ||============================== //

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.user = action.payload;
      state.isLoggedIn = true;
    },

    logoutSuccess(state) {
      state.user = null;
      state.isLoggedIn = false;
    }
  }
});

// Reducer
export default auth.reducer;

// Actions
export const { loginSuccess, logoutSuccess } = auth.actions;

export function login() {
  const utm_campaign = getQueryVariable("utm_campaign");
  return async () => {
    window.FP.login(function (response: User) {
      // 登录成功后 response 为userInfo
      localStorage.setItem("koa-webtools-auth", JSON.stringify(response));
      dispatch(auth.actions.loginSuccess(response));
      window.location.href = `/?login=1${utm_campaign && `&utm_campaign=${utm_campaign}`}`;
    });
  };
}

export function logout() {
  return async () => {
    window.FP.logout();
    dispatch(auth.actions.logoutSuccess());
  };
}

export function checkLogin(callback?: (user: User) => void) {
  return async () => {
    window.FP.checkLogin(function (response: User) {
      if (response) {
        // 已登录response 为userInfo
        localStorage.setItem("koa-webtools-auth", JSON.stringify(response));
        dispatch(auth.actions.loginSuccess(response));
      } else {
        // 未登录时 response === null
        // 可以在此时进行登录操作 或 其他自定义行为
        //dispatch(login());
        localStorage.removeItem("koa-webtools-auth");
        dispatch(auth.actions.logoutSuccess());
      }

      callback && callback(response);
    });
  };
}

// ----------------------------------------------------------------------

export interface User {
  uid: number;
  name: string;
  server: number;
  icon: string;
  lang: string;
  country: string;
  currency: string;
  level: number;
  security_verify: boolean;
  social_bind: boolean;
  token: string;
  openid: string;
  fpid: string;
}

export interface AuthState {
  isLoggedIn: boolean;
  isInitialized: boolean;
  user: null | User;
}
